import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import FoundersData from "../FoundersData/FoundersData";

const COPY = {
  title: "Founders Requests",
  subtitle: "You Can See & Edit Detail About Requests of Founders",
  searchPlaceholder: "Search Here",
};

const FoundersAdmin = () => {
  const { items, loading, searchValue, setSearchValue } = useAdminList(
    "getUsers",
    "fullName"
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <FoundersData driverData={items} />
    </AdminPage>
  );
};

export default FoundersAdmin;
